export default {
  messages: {
    offerItem: {
      create: 'New offerItem',
      update: 'Update offerItem',
      module: {
        name: 'OfferItem'
      },
      entity: {
        id: 'Id',
        offer: 'Offer',
        budgetLine: 'BudgetLine',
        description: 'Description',
        cost: 'Cost',
        count: 'Count',
        unit: 'Unit',
        unitPrice: 'UnitPrice',
        createdBy: 'CreatedBy',
        updatedBy: 'UpdatedBy',
        createdAt: 'CreatedAt',
        updatedAt: 'UpdatedAt'
      },
      grid: [],
      actions: {
        create: 'Create',
        update: 'Update',
        delete: 'Delete'
      }
    }
  }
};
